type props = {
  show?: boolean
  classSize?: string
  wrapperClass?: string
  spinClass?: string
}

export function LoaderSpin({ show = true, classSize = 'w-5 h-5', wrapperClass = '', spinClass = 'border-t-deep-grey' }: props) {
  return (
    show && (
      <div className={`absolute top-0 left-0 w-full h-full flex items-center justify-center z-20 ${wrapperClass}`}>
        <div className={`relative ${classSize}`}>
          <div className={`absolute top-0 left-0 animate-spin rounded-full border-solid border-2 border-[#F5F5F5] ${classSize} ${spinClass}`}></div>
        </div>
      </div>
    )
  )
}
